function Loader() {
  return <p className="loader">Loading...</p>;
}

export default Loader;
